import { createSlice } from '@reduxjs/toolkit';
import doctorApi from './doctorApi';

const dataSlice = createSlice({
    name: 'doctor',
    initialState: {
        doctorList: [],
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            doctorApi.endpoints.doctorList.matchFulfilled,
            (state, action) => {
                state.doctorList = action.payload; // Save the new data to the state
            }
        );
    },
});

export default dataSlice.reducer;
